// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/app-window.js';

import { paths } from '../generated/app-window';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('app-window', Original, paths);
